import { Link } from 'react-router-dom';
import { hotTopics } from '@/mocks/site';

export default function HotTicker() {
  const loop = [...hotTopics, ...hotTopics];

  return (
    <section className="w-full bg-primary-950 text-background-100 border-y border-primary-900" aria-label="热瓜速递">
      <div className="flex items-stretch">
        <div className="shrink-0 flex items-center gap-2 px-4 md:px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-flashlight-fill" />
          </span>
          热瓜速递
        </div>
        <div className="relative flex-1 overflow-hidden group">
          <div className="flex items-center gap-8 py-3 animate-marquee group-hover:[animation-play-state:paused] w-max">
            {loop.map((topic, index) => (
              <Link
                key={`${topic.caseId}-${index}`}
                to={`/case/${topic.caseId}`}
                className="flex items-center gap-2 text-sm whitespace-nowrap text-background-200/90 hover:text-accent-400 transition-colors"
              >
                <span className="px-1.5 py-0.5 rounded bg-background-50/10 text-[11px] font-semibold text-accent-400">
                  热度 {topic.heat}
                </span>
                {topic.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}